export const MARKETING_REPORTS_ALLOWED_EMAILS = [
  'guillermo.mezzano04@gmail.com',
  'eduardo@tryluca.cl',
  'lucila@tryluca.cl'
]

export const canAccessMarketingReports = email =>
  !!email && MARKETING_REPORTS_ALLOWED_EMAILS.includes(email.trim().toLowerCase())
